import httpClient from "./httpClient";
import notes from "./note.js";

const entityEndpoint = "/bookings";

export default {
  /**
   * Bookings
   */
  async getBookings(params) {
    const response = await httpClient.get(`/bookings`, {
      params
    });
    return response.data;
  },

  async getBooking(id) {
    const response = await httpClient.get(`/bookings/${id}`);
    return response.data;
  },

  async createBooking(booking) {
    booking.creator = "crm";
    const response = await httpClient.post(`/bookings`, {
      ...booking
    });
    return response.data;
  },

  async cancelBooking(args) {
    let { booking, withCredit } = args;
    const response = await httpClient.post(`/bookings/${booking.id}/cancel`, {
      ...args
    });

    return response.data;
  },

  async deleteBooking(booking) {
    const response = await httpClient.delete(`/bookings/${booking.id}`);
    return response.data;
  },

  async updateBooking(booking) {
    const response = await httpClient.put(`${entityEndpoint}/${booking.id}`, {
      ...booking
    });
    return response.data;
  },

  async changeDeparture(booking, departure) {
    const response = await httpClient.put(
      `${entityEndpoint}/${booking.id}/departure`,
      {
        departure: departure.id
      }
    );
    return response.data;
  },

  /**
   * Travellers
   */
  async addTraveller(args) {
    const response = await httpClient.post(
      `/bookings/${args.booking.id}/travellers`,
      {
        ...args.traveller
      }
    );
    return response.data;
  },

  async updateTraveller(args) {
    const response = await httpClient.put(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}`,
      {
        ...args.traveller
      }
    );
    return response.data;
  },

  async removeTraveller(args) {
    const response = await httpClient.delete(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}`
    );
    return response.data;
  },

  async addTravellerExtra(args) {
    const response = await httpClient.post(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}/extras`,
      {
        ...args.extra
      }
    );
    return response.data;
  },

  async removeTravellerExtra(args) {
    const response = await httpClient.delete(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}/extras/${args.extra.id}`
    );
    return response.data;
  },

  async updateTravellerExtra(args) {
    const response = await httpClient.put(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}/extras/${args.extra.id}`,
      {
        ...args.extra
      }
    );
    return response.data;
  },

  async assignTravellerTicket(args) {
    const response = await httpClient.put(
      `/bookings/${args.booking.id}/travellers/${args.traveller.id}/ticket/${args.ticket.id}`,
      {}
    );
    return response.data;
  },

  async updateTravelInfo(booking, args) {
    const response = await httpClient.put(
      `/bookings/${booking.id}/travellers/${args.id}/travel-info`,
      {
        ...args.travel_info
      }
    );
    return response.data;
  },

  /**
   * Financials
   */
  async getFinancials(id) {
    const response = await httpClient.get(`/bookings/${id}/financials`);
    return response.data;
  },

  async getTransactions(booking) {
    const response = await httpClient.get(
      `/bookings/${booking.id}/transactions`
    );
    return response.data;
  },

  async postTransaction(booking, transaction) {
    const response = await httpClient.post(
      `/bookings/${booking.id}/transactions`,
      {
        ...transaction
      }
    );
    return response.data;
  },

  async deleteTransaction(booking, transaction) {
    const response = await httpClient.delete(
      `/bookings/${booking.id}/transactions/${transaction.id}`
    );
    return response.data;
  },

  async getDiscounts() {
    const response = await httpClient.get(`/discounts`);
    return response.data;
  },

  async removeDiscount(booking) {
    const response = await httpClient.delete(
      `/bookings/${booking.id}/discount`
    );
    return response.data;
  },

  async addDiscount(booking, discount) {
    const response = await httpClient.post(`/bookings/${booking.id}/discount`, {
      ...discount
    });
    return response.data;
  },

  /**
   * Emails
   */
  async sendBookingInvoice(bookingId) {
    const response = await httpClient.post(
      `/bookings/${bookingId}/email-invoice`
    );
    return response.data;
  },

  async getNewBookings() {
    const response = await httpClient.get("/widgets/new-bookings");
    return response.data;
  },

  async getMonthlyBookingCount() {
    const response = await httpClient.get("/widgets/monthly-booking-count");
    return response.data;
  },
  async reserveBooking(booking) {
    const response = await httpClient.post(`/bookings/${booking.id}/reserve`);
    return response.data;
  },

  /**
   * Notes
   */
  ...notes
};
